import { createFileRoute } from '@tanstack/react-router';
import { BroadcastDraftRouteView } from '@/pages/workspaces/broadcasts/broadcast/routing';

function BroadcastDraftRoute() {
  const { broadcastId, deliveryId } = Route.useParams();
  return <BroadcastDraftRouteView broadcastId={broadcastId} deliveryId={deliveryId} />;
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/broadcasts_/broadcast/$broadcastId/overview/drafts/$deliveryId',
)({
  component: BroadcastDraftRoute,
});
